import { render, staticRenderFns } from "./LanguageSwapper.vue?vue&type=template&id=337f036d"
import script from "./LanguageSwapper.vue?vue&type=script&lang=js"
export * from "./LanguageSwapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports